import * as React from "react";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import MenuIcon from "@mui/icons-material/Menu";
import { Typography } from "@mui/material";
import { NavLink } from "react-router-dom";

export default function AnchorTemporaryDrawer() {
  const [state, setState] = React.useState({
    top: false,
  });

  const location = useLocation(); // Get current route

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const menuItems = [
    { text: "Home", path: "/" },
    { text: "About Us", path: "/aboutus" },
    { text: "Expertise", path: "/solutions" },
    { text: "Case Studies", path: "/casestudies" },
    { text: "Thinking", path: "/thinking" },
    { text: "Events", path: "/events" },
    { text: "Contact Us", path: "/contactus" },
  ];

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
        borderRadius: "0 0 16px 16px",
        overflow: "hidden",
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Typography
        sx={{
          color: "#333",
          fontSize: "1.2rem",
          fontWeight: "700",
          padding: "1.5rem",
          borderBottom: "2px solid #eee",
          boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.08)",
        }}
      >
        MENU
      </Typography>
      <List sx={{ padding: "0.8rem 0" }}>
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path; // Check if it's active

          return (
            <ListItem
              key={item.text}
              disablePadding
              sx={{
                padding: 0,
                borderBottom:
                  menuItems.length - 1 === menuItems.indexOf(item)
                    ? "none"
                    : "1px solid #eee",
                backgroundColor: isActive ? "#F36B2B" : "transparent",
              }}
            >
              <NavLink
                to={item.path}
                style={{
                  textDecoration: "none",
                  width: "100%",
                  padding: "1rem 1.5rem",
                  display: "block",
                  color: isActive ? "white" : "#F36B2B",
                  fontWeight: isActive ? "500" : "400",
                  fontSize: "0.95rem",
                }}
              >
                {item.text}
              </NavLink>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );

  return (
    <div>
      {["top"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              onClick={toggleDrawer(anchor, true)}
              edge="start"
              color="inherit"
              aria-label="menu"
            >
              <MenuIcon sx={{ color: "white" }} />
            </IconButton>
          </Box>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            PaperProps={{
              sx: {
                borderBottomLeftRadius: "1.5rem",
                borderBottomRightRadius: "1.5rem",
                margin: "0 auto",
              },
            }}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
